<template>
  <span>{{list}}</span>
</template>

<script>
export default {
  name: 'WordList',
  props: {
    values: {
      type: Array,
      required: true
    }
  },
  computed: {
    list() {
      return this.values.join(', ');
    }
  }
}
</script>
